import jQuery from 'jquery';
import Swiper, {Lazy, Navigation, Scrollbar } from 'swiper';
Swiper.use([Navigation, Lazy, Scrollbar]);
import LazyLoad from 'vanilla-lazyload';
import { createPopper } from '@popperjs/core';
import resizeSensor from 'resize-sensor';
import stickySidebar from "sticky-sidebar";
import skrollr from 'skrollr';
import Cookie from "js-cookie";
import 'jquery-inview';

(function ($) {
  $(document).ready(function () {
    $('#gmw-map-wrapper-5').append($('.gmw-results-items'));
    $(".gmw-keywords-field-wrapper input").attr('disabled', 'disabled');
    $( "<button type='reset' id='map-form-reset' class='close'></button>" ).insertAfter( ".gmw-address-field-wrapper" );
    $('#gmw-map-wrapper-5').append($('.fax-email'));
    $('.footer__links ul.footer__list:last-child li.footer__list-item:first-child a').attr('target','_blank');

    $('.gmw-item-title a').click(function () {
      $(this).removeAttr("href");
    })

    $("body").on("inview", ".loadMoreBtn", function (event, isInView) {
      $('.products').find('.loadMoreBtn')[0].click();
    });

    setTimeout(function () {
      $('.wrapper-display').removeClass('d-opacity');
    }, 500);
    if ($('.strain-galleries').length && $(window).width() > 1024) {
      var s = skrollr.init({
        duration: 50000
      });
    }

    var lazyLoadInstance = new LazyLoad({
      unobserve_entered: true,
      callback_loaded : intiStickySidebar
    });
    var audio = document.querySelector('#hero-audio');

    //mute on unmute
    $('.hero__music').on('click', togglePlay)

    // play pause video with sound
    function togglePlay() {
      var pauseIcon = $('.hero__music-pause'),
          playIcon = $('.hero__music-play')
      if (audio.muted) {
        audio.muted = false;
        pauseIcon.hide();
        playIcon.show();
        audio.play();
      } else {
        audio.muted = true;
        playIcon.hide();
        pauseIcon.show();
        audio.pause();
      }
    }



    //mobile nav
    $('.js-mobi-button').on('click', function () {
      $('header').toggleClass('header--open');
      $('.header__navbar').slideToggle();
    });


    //feature carousel
    var featureCarousel = function () {
      if ($(window).width() < 768) {
        var swiper = new Swiper('#feature-carousel', {
          slidesPerView: 1,
          width: 252,
          scrollbar: {
            el: '#feature-carousel .swiper-scrollbar',
          }
        });
      }
    }

    featureCarousel();

    //our product carousel
    var productCarousel = function () {
      var swiper = new Swiper('#our-carousel', {
        scrollbar: {
          el: '.our-product-scrollbar',
        },
        // Responsive breakpoints
        breakpoints: {
          320: {

            slidesPerView: 'auto',
            // initialSlide: 1,
            centeredSlides: true,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          }
        }
      });
    }

    productCarousel();

    //single product Carousel
    function strainCarousel() {
      var swiper = new Swiper('#strain-carousel', {
        scrollbar: {
          el: '.our-product-scrollbar',
        },
        // Responsive breakpoints
        breakpoints: {
          320: {

            slidesPerView: 'auto',
            // initialSlide: 1,
            centeredSlides: true,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          }
        }
      });
    }

    strainCarousel();


    //cookie
    if (!$.cookie('cookie')) {
      setTimeout(function () {
        $('.cookie').show();
      }, 3000);
    }

    $('.cookie__button').click(function () {
      $.cookie('cookie', true, {
        path: '/'
      });
      $('.cookie').hide();
    });


    //show newsletter
    function showNewsletter() {
      var windowHeight = $(window).outerHeight();

      $(window).on('scroll', function () {

        var scrollPosition = $(this).scrollTop(); //store window scroll position

        // if window scroll position goes up windowHeight and newsletter cookie not found
        if (scrollPosition > windowHeight && !$.cookie('newsletter')) {
          $('.popup').fadeIn();
        }
      })



      //if cooke found and newsletter cookie not found
      if ($.cookie('cookie') && !$.cookie('newsletter')) {
        $('.popup').fadeIn();
      }
    }

    showNewsletter();

    //close popup
    $('.popup__close').on('click', function (e) {
      $.cookie('newsletter', true, {
        path: '/'
      });
      $('.popup').fadeOut();
    })


    //accordion
    $('.filter__title').on('click', function () {
      var _this = $(this);
      _this.parent().siblings().removeClass('open').find(' > .filter__list').slideUp();
      _this.parent().toggleClass('open').find(' > .filter__list').slideToggle();
    })


    //tooltip
    const button = document.querySelectorAll('.js-tooltip');
    let popperInstance = null;

    //create tooltip;
    function create() {
      button.forEach(function (element) {
        var tooltip = $(element).attr('data-tooltip'),
            tooltip = document.querySelector('#' + tooltip);

        if ($(window).width() >= 768) {
          popperInstance = createPopper(element, tooltip, {
            strategy: 'fixed',
            placement: 'bottom'
          });
        } else {
          popperInstance = createPopper(element, tooltip, {
            strategy: 'fixed',
            placement: 'bottom',
            modifiers: [{
              name: 'offset',
              options: {
                offset: [-321, 0],
              },
            }, ],
          });
        }
      });
    }

    //destroy tooltip
    function destroy() {
      if (popperInstance) {
        popperInstance.destroy();
        popperInstance = null;
      }
    }

    //show and hide on mouse over toolti
    button.forEach(function (element) {
      var tooltipbody;
      $(element).on('mouseenter focus', function () {
        tooltipbody = $(this).attr('data-tooltip');
        $('#' + tooltipbody).attr('data-show', true)
        create();
      }).on('mouseleave blur', function () {
        $('#' + tooltipbody).attr('data-show', false)
        destroy();
      })
    })


    //show filter
    if ($(window).width() >= 1200) {
      $('.js-filter-open').on('click', function (e) {
        e.stopPropagation();
        $('.filter__topbar').toggleClass('filter__topbar--active');
        $('.filter__content').toggleClass('filter__content--show');
      })
    } else {
      $('.filter__topbar').on('click', function () {
        $('.filter__topbar').toggleClass('filter__topbar--active');
        $('.filter__content').toggleClass('filter__content--show');
      })
    }

    $('body').on('click', function () {
      hideFilter();
    })


    //show filter
    function showFilter() {
      $('.filter__topbar').addClass('filter__topbar--active');
      $('.filter__content').addClass('filter__content--show');
    }

    //hide Filter
    function hideFilter() {
      $('.filter__topbar').removeClass('filter__topbar--active');
      $('.filter__content').removeClass('filter__content--show');
    }

    $('.filter__topbar, .filter__content').on('click', function (e) {
      e.stopPropagation();
    });

    //sticky filter
    var stickyFilter = function () {
      var getHeaderHeight = $('.header').outerHeight(),
          filter = $('.filter'),
          getFilterPosition;

      if (filter.length) {
        getFilterPosition = filter.offset().top;
      } else {
        return;
      }

      $(window).on('scroll', function () {
        var windowScrollPos = $(window).scrollTop();
        if (windowScrollPos >= getFilterPosition) {
          filter.addClass('filter--sticky');
          $('.filter__placeholder').outerHeight(getHeaderHeight)
        } else {
          filter.removeClass('filter--sticky')
          $('.filter__placeholder').outerHeight('auto')
        }
      })
    }

    stickyFilter();


    //sticky sound
    function stickySound() {
      var $animation_elements = $('.footer'),
          $window = $(window);
      var $sound = $('.hero__music');

      function check_if_in_view() {
        var window_height = $window.height(),
            window_top_position = $window.scrollTop(),
            window_bottom_position = (window_top_position + window_height);

        $.each($animation_elements, function () {
          var $element = $(this),
              element_height = $element.outerHeight(),
              element_top_position = $element.offset().top - 100,
              element_bottom_position = (element_top_position + element_height);

          //check to see if this current container is within viewport
          if (element_top_position <= window_bottom_position) {
            $sound.fadeOut();
          } else {
            $sound.fadeIn();
          }
        });
      }

      $window.on('scroll resize', check_if_in_view);
      $window.trigger('scroll');
    }

    stickySound();


    //image loading animation
    function imageLoadingAnimation() {
      var $animation_elements = $('.animate-blur'),
          $window = $(window);

      function check_if_in_view() {
        var window_height = $window.height(),
            window_top_position = $window.scrollTop(),
            window_bottom_position = (window_top_position + window_height);

        $.each($animation_elements, function () {
          var $element = $(this),
              element_height = $element.outerHeight(),
              element_top_position = $element.offset().top + 50,
              element_bottom_position = (element_top_position + element_height);

          //check to see if this current container is within viewport
          if (element_top_position <= window_bottom_position) {
            $element.addClass('animate-blur--loaded');
          }
        });
      }

      $window.on('scroll resize', check_if_in_view);
      $window.trigger('scroll');
    }
    imageLoadingAnimation();


    //product filter
    $('.filter__list a').click(function (e) {
      var query = getUrlParams();
      var type = $(this).data('type');
      var handle = $(this).data('handle');
      query[type] = handle;
      window.location.href = window.location.pathname + "?" + $.param(query);

    })

    function getUrlParams() {
      var vars = {},
          hash;
      var href = window.location.href;
      if (href.includes("?")) {
        var hashes = href.slice(href.indexOf('?') + 1).replace('#', '').split('&');
        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          vars[hash[0]] = hash[1];
        }
      }
      return vars;
    }

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      $('.pagination__list-link').each(function () {
        $(this).addClass("pagination__list-link--safari")
      })
    }

    //newsletter
    $('.newsletter, .popup form').on('submit', function (e) {
      var email = $(this).find('[type="email"]'),
          emailValue = email.val();
      if (!validateEmail(emailValue)) {
        e.preventDefault();
        $(this).addClass('newsletter--error');
      } else {
        $(this).removeClass('newsletter--error');
      }
    })

    //checking email
    function validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    //checking email while typing;
    $('.newsletter__input').on('keyup', function (e) {
      var email = $(this).val(),
          form = $(this).parents(form);
      if (!validateEmail(email)) {
        e.preventDefault();
        form.addClass('newsletter--error');
      } else {
        form.removeClass('newsletter--error');
      }
    })


    //lazy load animation
    function lazyLoadAnimation() {
      var $animation_elements = $('.animate'),
          $window = $(window);

      function check_if_in_view() {
        var window_height = $window.height(),
            window_top_position = $window.scrollTop(),
            window_bottom_position = (window_top_position + window_height);

        $.each($animation_elements, function () {
          var $element = $(this),
              element_height = $element.outerHeight(),
              element_top_position = ($(window).width() > 768) ? $element.offset().top + 50 : $element.offset().top - 0,
              element_bottom_position = (element_top_position + element_height);

          //check to see if this current container is within viewport
          if (element_top_position <= window_bottom_position) {
            $element.addClass('in-view');
          } else {
            $element.removeClass('in-view');
          }
        });
      }

      $window.on('scroll resize', check_if_in_view);
      $window.trigger('scroll');
    }

    lazyLoadAnimation();

    function intiStickySidebar() {
      if ($(window).width() >= 992) {

        if ($('.misc__img').length) {
          var miscSidebar = new StickySidebar('.misc__img', {
            containerSelector: '.misc',
            topSpacing: 68,
            bottom: 0,
          });
          miscSidebar.updateSticky();
        }

        if ($('.single-product__gallery').length) {
          var productSidebar = new StickySidebar('.single-product__gallery', {
            containerSelector: '.single-product',
            innerWrapperSelector: '.single-product__gallery-inner',
            topSpacing: 72,
            resizeSensor: true
          });
          productSidebar.updateSticky();
        }
      }
    }


    //dropdown
    $('.nav__item.nav__item--has-dropdown').on('click', function () {
      if ( $(window).width() < 768) {
        $(this).toggleClass('open').find('.dropdown').slideToggle();
      }
    })

    //single product sticky
    $('.single-product__nav-text').on('click', function() {
      $(this).parent().toggleClass('open').find('.single-product__nav-menu').slideToggle();
    })

  })


  $(".age__cta-link_yes").click(function () {
    Cookie.set('ageGate', true)
    $('.age__inner').fadeOut(function () {
      setTimeout(function () {
        $("section.age").fadeOut();
        $('html').css('overflow', 'visible');
      }, 1000)
    });
  });


  if (!Cookie.get('ageGate')) {
    $("section.age").fadeIn(function () {
      $('html').css({
        'overflow': 'hidden'
      });
      setTimeout(function () {
        $('.age__inner').addClass('visible');
      }, 1000)
    });
  }

  // $('audio').each(function (index, audio) {
  //     $(audio).attr("src", $(audio).data('src'));
  //     $(audio).removeAttr('data-src');
  // })
  //
  //
  // $(window).on('load', function() {
  //     setTimeout(function() {
  //         $('#hero-audio')[0].play();
  //     })
  // })

})(jQuery)